<forge-card fxFill class="chart" no-padding>
    <forge-toolbar>
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">{{chartTitle}}</h2>
            <span class="forge-typography--subheading1">{{chartSubtitle}}</span>
        </div>

        <!-- TODO - move ariaLabel to behind method/property -->
        @if (showChartSettings)
        {
        <forge-icon-button slot="end" (click)="displayChartParameterDialogAndReload()"
            attr.aria-label="Chart-Settings-{{chartProviderId}}">
            <forge-tooltip>Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
        }
    </forge-toolbar>

    <div [formGroup]="chartsFormGroup" fxLayout="column" fxLayoutAlign="start stretch" class="card-body">
        @if (isLoaded())
        {

        @if (hasData())
        {

        @for(commonChartData of commonChartDatas(); track $index)
        {
        <!-- TODO - looks like a good boundary for a component... just sayin'.... -->

        @if (hasChartCriteria())
        {

        @if (commonChartData.ShowDrillDownSelect)
        {
        <div fxLayout="row" fxLayoutAlign="start start">
            <lgd-select [controlName]="commonChartData.$controlName!" fxFlex="50"
                [label]="commonChartData.DrillDownSelectName!" [options]="getOptions(commonChartData)"
                [placeholder]="commonChartData.DrillDownSelectName!">
            </lgd-select>
        </div>
        }

        @if (commonChartData.ShowDateOptions)
        {
        <common-chart-date-options [dateOptions]="commonChartData.DateOptions!" [endDate]="commonChartData.EndDate!"
            [selectedDateOption]="commonChartData.SelectedDateOption!" [startDate]="commonChartData.StartDate!"
            (onDateChange)="onDateChange($event)" (onDateOptionChange)="onDateOptionChange($event)">
        </common-chart-date-options>
        }

        }

        @if (commonChartData.InfoCards)
        {
        <div fxLayout="row" fxLayoutAlign="space-between center">
            @if (showChartLabels) {
            <h4>{{commonChartData.Labels![0]}}</h4>
            }

            @for (infoCard of commonChartData.InfoCards; track $index) {
            <common-chart-info-card [commonChartInfoCard]="infoCard" fxFlex="100%">
            </common-chart-info-card>
            }
        </div>
        }

        @if (commonChartData.HasData)
        {
        <lgd-chart #lgdChart [data]="commonChartData">
        </lgd-chart>

        @if (hasChartCriteria())
        {

        @if (commonChartData.UsePaginator)
        {
        <div fxLayout="row" fxLayoutAlign="end center" class="paginator">
            <mat-paginator [length]="commonChartData.ChartPaginator!.TotalItemCount" (page)="pageChange($event)"
                [pageIndex]="commonChartData.ChartPaginator!.PageIndex"
                [pageSize]="commonChartData.ChartPaginator!.PageSize"
                [pageSizeOptions]="commonChartData.ChartPaginator!.PageSizeOptions">
            </mat-paginator>
        </div>
        }

        }

        @if (commonChartData.ShowViewMoreButton)
        {
        <div fxLayout="row" fxLayoutAlign="end center">
            <forge-button variant="link">
                <a [href]="getViewMoreUrl(commonChartData.ViewMoreUrl!)" telemetry="Submission-ViewMore">
                    <label>View more</label>
                </a>
            </forge-button>
        </div>
        }

        @if (showShareAction())
        {
        <div fxLayout="row" fxLayoutAlign="end center">
            <forge-icon-button (click)="shareChart(lgdChart)" attr.aria-label="Chart-Share-{{chartProviderId}}">
                <forge-icon name="share"></forge-icon>
                <forge-tooltip position="bottom">Share</forge-tooltip>
            </forge-icon-button>
        </div>
        }

        }
        @else
        {
        <div class="noDataChart">{{commonChartData.NoDataMessage}}</div>
        }

        }

        }
        @else
        {
        <div class="noDataChartCriteria">Not enough data to display graph</div>
        }

        }
        @else
        {
        <busy-indicator [chart]="true"></busy-indicator>
        }
    </div>
</forge-card>